import { render, staticRenderFns } from "./CsRevisionIndex.vue?vue&type=template&id=5bcedbfe"
import script from "./CsRevisionIndex.vue?vue&type=script&lang=js"
export * from "./CsRevisionIndex.vue?vue&type=script&lang=js"
import style0 from "./CsRevisionIndex.vue?vue&type=style&index=0&id=5bcedbfe&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports